import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'amount',
})
export class AmountPipe implements PipeTransform {
  transform(value: string): unknown {
    const index = value.indexOf('i')
    if (index < 0) {
      return value
    }
    let amountChar = null
    if (value.charAt(index - 1) === 'r') {
      amountChar = value.substring(0, index - 1).toUpperCase()
    } else {
      amountChar = value.substring(0, index).toUpperCase()
    }
    return amountChar
  }
}
